import React from 'react';
import ReactDOM from 'react-dom';
import './PrivacyPolicyModal.css';

export default function PrivacyPolicyModal({ show, onClose, type = 'terms' }) {
  if (!show) return null;

  const isTerms = type === 'terms';
  const title = isTerms ? 'Terms and Conditions' : 'Privacy Policy';
  const icon = isTerms ? '📋' : '🔒';

  const termsContent = (
    <div className="policy-content">
      <h3>Terms and Conditions</h3>
      <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
      
      <section>
        <h4>1. Acceptance of Terms</h4>
        <p>By accessing and using Garden of Memories services, you accept and agree to be bound by the terms and provision of this agreement.</p>
      </section>

      <section>
        <h4>2. Use License</h4>
        <p>Permission is granted to temporarily access Garden of Memories services for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.</p>
      </section>

      <section>
        <h4>3. Service Availability</h4>
        <p>We strive to maintain high service availability but do not guarantee uninterrupted access. We reserve the right to modify or discontinue services with reasonable notice.</p>
      </section>

      <section>
        <h4>4. User Responsibilities</h4>
        <p>Users are responsible for:</p>
        <ul>
          <li>Providing accurate and complete information</li>
          <li>Maintaining the security of their account credentials</li>
          <li>Complying with all applicable laws and regulations</li>
          <li>Respecting the rights and privacy of other users</li>
        </ul>
      </section>

      <section>
        <h4>5. Prohibited Uses</h4>
        <p>You may not use our services:</p>
        <ul>
          <li>For any unlawful purpose or to solicit others to perform unlawful acts</li>
          <li>To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances</li>
          <li>To infringe upon or violate our intellectual property rights or the intellectual property rights of others</li>
          <li>To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate</li>
        </ul>
      </section>

      <section>
        <h4>6. Reservation and Payment Terms</h4>
        <p>All reservations are subject to availability and our approval. Payment terms and cancellation policies are outlined in individual service agreements.</p>
      </section>

      <section>
        <h4>7. Limitation of Liability</h4>
        <p>In no event shall Garden of Memories, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages.</p>
      </section>

      <section>
        <h4>8. Changes to Terms</h4>
        <p>We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through our service.</p>
      </section>

      <section>
        <h4>9. Contact Information</h4>
        <p>If you have any questions about these Terms and Conditions, please contact us at support@gardenofmemories.com</p>
      </section>
    </div>
  );

  const privacyContent = (
    <div className="policy-content">
      <h3>Privacy Policy</h3>
      <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
      
      <section>
        <h4>1. Information We Collect</h4>
        <p>We collect information you provide directly to us, such as when you create an account, make a reservation, or contact us for support.</p>
        <ul>
          <li>Personal information (name, email, phone number)</li>
          <li>Account credentials and preferences</li>
          <li>Reservation and service history</li>
          <li>Communication records</li>
        </ul>
      </section>

      <section>
        <h4>2. How We Use Your Information</h4>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Process reservations and transactions</li>
          <li>Send you technical notices and support messages</li>
          <li>Respond to your comments and questions</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section>
        <h4>3. Information Sharing</h4>
        <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except:</p>
        <ul>
          <li>To trusted service providers who assist us in operating our services</li>
          <li>When required by law or to protect our rights</li>
          <li>In connection with a business transfer or acquisition</li>
        </ul>
      </section>

      <section>
        <h4>4. Data Security</h4>
        <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
      </section>

      <section>
        <h4>5. Data Retention</h4>
        <p>We retain your personal information for as long as necessary to provide our services and comply with legal obligations.</p>
      </section>

      <section>
        <h4>6. Your Rights</h4>
        <p>You have the right to:</p>
        <ul>
          <li>Access and update your personal information</li>
          <li>Request deletion of your account and data</li>
          <li>Opt out of marketing communications</li>
          <li>Request a copy of your data</li>
        </ul>
      </section>

      <section>
        <h4>7. Cookies and Tracking</h4>
        <p>We use cookies and similar technologies to enhance your experience and analyze usage patterns. You can control cookie settings through your browser.</p>
      </section>

      <section>
        <h4>8. Children's Privacy</h4>
        <p>Our services are not intended for children under 13. We do not knowingly collect personal information from children under 13.</p>
      </section>

      <section>
        <h4>9. Changes to Privacy Policy</h4>
        <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>
      </section>

      <section>
        <h4>10. Contact Us</h4>
        <p>If you have any questions about this Privacy Policy, please contact us at privacy@gardenofmemories.com</p>
      </section>
    </div>
  );

  return ReactDOM.createPortal(
    <div className="booking-modal-overlay" onClick={onClose}>
      <div className="booking-modal-content" onClick={e => e.stopPropagation()}>
        <div className="booking-modal-icon">{icon}</div>
        <h3>{title}</h3>
        <p>Please review our {isTerms ? 'terms and conditions' : 'privacy policy'} below</p>
        <div className="privacy-modal-body">
          {isTerms ? termsContent : privacyContent}
        </div>
        <div className="booking-modal-actions">
          <button className="booking-btn-modal" onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
